import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { apiGetAllCustomerWithDevice } from '@services/ManageCustomers/CustomerServices';
import { Col, Input, Row, Skeleton, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import OpenLayersMap from './components/Maps';
import { debounce } from 'lodash';

const { Text } = Typography;

const { Search } = Input;

export const Maps = () => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [customers, setCustomers] = useState([]);
  const fetch = async (keyWord) => {
    try {
      setLoading(true);
      const res = await apiGetAllCustomerWithDevice({ keyWord });
      const convertData = res?.data?.data?.length
        ? res?.data?.data?.map((cust) => ({
            id: cust?.id || '',
            name: cust?.name || '',
            code: cust?.code || '',
            address: cust?.address || '',
            lat: cust?.latitude || '',
            lng: cust?.longitude || '',
            serial_no: cust?.device_information?.serial_no,
            model: cust?.device_information?.model,
            meter_reading: cust?.device_information?.meter_reading,
            device_id: cust?.device_information?.id,
            status: cust?.device_information?.status,
            last_seen_at: cust?.device_information?.last_seen_at,
            rsrp: cust?.device_information?.rsrp,
            snr: cust?.device_information?.snr,
            battery_capacity: cust?.device_information?.battery_capacity,
            alarm_status: cust?.device_information?.alarm_status
          }))
        : [];
      setCustomers(convertData);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const onSearch = (value, _e, info) => {
    fetch(value);
  };
  useEffect(() => {
    fetch();
  }, []);
  return (
    <>
      <OpenLayersMap markers={customers} onSearch={onSearch} />
    </>
  );
};
